var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.virtualReminder)?_c('li',[_vm._v("\n    "+_vm._s(_vm.virtualReminder.delay)+" minutes "+_vm._s(_vm.$t('coupon.virtualReminder'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }